var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8929 10.6016C25.6289 12.8311 27.1116 19.1113 22.8997 24.9564L22.6257 25.1982C21.1591 24.3762 19.4722 23.9088 17.6724 23.9088C13.9064 23.9088 10.6293 25.9557 8.86719 28.9964H26.4777C25.9351 28.0617 25.2474 27.2182 24.447 26.4983",
    stroke: "#003D6A",
    strokeWidth: 0.80585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74414 18.0234C8.06111 19.9575 8.86159 22.2568 10.7043 24.3091",
    stroke: "#003D6A",
    strokeWidth: 0.80585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7288 5.70005C27.7596 3.1267 30.4296 3.86271 33.3629 2.83659C26.9268 -0.698404 23.8915 3.34696 23.8915 3.34696C23.8377 3.36308 23.1555 2.19191 23.6229 0C20.7487 1.63319 20.9689 4.06149 20.9152 4.02388C20.9152 4.02388 18.9274 2.90106 15.5912 4.96941C18.1914 4.74914 19.6849 5.71617 19.7064 5.82361C19.7064 5.82361 13.9312 7.49978 13.8828 13.6242C17.3587 10.1483 19.787 8.76228 19.8676 8.79989L19.9159 8.75153C19.8085 8.7193 18.0786 12.9366 20.5284 16.8423C21.1784 10.648 24.3696 8.7784 24.2837 8.61723V8.62797C24.332 8.69244 28.6729 12.0072 32.3744 11.6204C30.3222 5.58723 25.7181 5.71079 25.7181 5.71079L25.7288 5.70005Z",
    fill: "#FFC000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15207 13.1693C4.36846 12.111 2.9609 13.1479 1 13.207C3.99776 9.66121 6.70542 11.3642 6.70542 11.3642C6.74303 11.3642 6.88271 10.5154 6.10372 9.32812C8.17207 9.64509 8.58574 11.1225 8.6126 11.0903C8.6126 11.0903 9.53127 9.97818 11.9703 10.4402C10.3855 10.9022 9.72467 11.8101 9.73542 11.88C9.73542 11.88 12.4162 11.7994 13.3994 14.5285C10.5628 13.266 10.3586 13.6314 10.3156 13.669L10.278 13.6529C10.3317 13.6099 12.3088 15.7051 11.75 18.5685C9.96106 15.0604 7.65633 14.679 7.66707 14.5608C7.65633 14.6145 5.84585 17.5532 3.57335 18.1656C3.41755 14.1417 6.16282 13.1693 6.16282 13.1693H6.15207Z",
    stroke: "#003D6A",
    strokeWidth: 0.80585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.728 5.70297C27.7587 3.12963 30.4288 3.86564 33.3621 2.83952C26.926 -0.695477 23.8906 3.34989 23.8906 3.34989C23.8906 3.34989 24.315 8.65776 24.2936 8.62015V8.6309C24.3419 8.69537 28.6828 12.0101 32.3843 11.6233C30.3321 5.59016 25.728 5.71372 25.728 5.71372V5.70297Z",
    fill: "#0098C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.957c24b6b70574c2bd41ff158d3af028.svg";
export { ForwardRef as ReactComponent };